import idx from "idx"

/**
 * transform - manipulate data from the graphql query
 * @param {object} contentfulVideo
 * @returns {object}
 */
function transform(contentfulVideo) {
  const title = idx(contentfulVideo, _ => _.title)
  const vimeoId = idx(contentfulVideo, _ => _.vimeoId)
  const videoUrl = idx(contentfulVideo, _ => _.videoUrl)
  const youTubeId = idx(contentfulVideo, _ => _.youTubeId)
  const preview = idx(contentfulVideo, _ => _.preview.file.url)
  const theme = "dark"
  const color = "fluro"

  return {
    theme,
    color,
    preview,
    title,
    vimeoId,
    videoUrl,
    youTubeId
  }
}

export default { transform }
